import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { getDomain } from 'typescript/utilities/environment';
import {
  GetApplicationFlowResponse,
  SubmitApplicationFlowRequestData,
  SubmitApplicationFlowResponse,
} from 'typescript/types/api/capital_shop/application_flows';

export const APPLICATION_FLOW_BASE_URL =
  '/api/v2/capital-shop/application-flows';

/**
 * Get application flow
 * @returns Metadata and data concerning the application Flow
 */
export const getApplicationFlow = async ({
  applicationFlowToken,
}: {
  applicationFlowToken: string;
}): Promise<GetApplicationFlowResponse> => {
  const response = await SqFetch.get(
    `https://${getDomain('app.')}${APPLICATION_FLOW_BASE_URL}/${applicationFlowToken}`,
  );

  return _handleResponse(response);
};

/**
 * Submit application flow
 * @returns Metadata about the application flow
 */
export const submitApplicationFlow = async ({
  applicationFlowToken,
  applicationFlowData,
}: {
  applicationFlowToken: string;
  applicationFlowData: SubmitApplicationFlowRequestData;
}): Promise<SubmitApplicationFlowResponse> => {
  const response = await SqFetch.post(
    `https://${getDomain('app.')}${APPLICATION_FLOW_BASE_URL}/${applicationFlowToken}/submit`,
    {
      data: {
        attributes: applicationFlowData,
        type: 'application_flows',
      },
    },
  );

  return _handleResponse(response);
};
